import { redirect } from '@tanstack/react-router'

import { authLoaders } from '@/modules/auth'

export const routeOptions = {
  validateSearch: (search: Record<string, unknown>) => ({
    redirect: typeof search.redirect === 'string' ? search.redirect : undefined,
    preview: search.preview === '1' || search.preview === true || undefined,
  }),
  beforeLoad: async ({
    search,
  }: {
    search: { redirect?: string; preview?: boolean }
  }) => {
    if (search.preview) return
    const session = await authLoaders().getSession()
    if (session) throw redirect({ to: search.redirect ?? '/' })
  },
}
